export enum SecurityTab {
  SECURITY = 'SECURITY',
}
